import { useMediaQuery as useMediaQueryHook } from "usehooks-ts";

const sizes = {
	xxs: 320,
	xs: 450,
	s: 496,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536,
	"3xl": 1792,
	"4xl": 2048,
};

interface Props {
	min?: keyof typeof sizes;
	max?: keyof typeof sizes;
	pointer?: "touch" | "no-touch";
}

export function useMediaQuery(props: Props) {
	const query = [];

	const min = props.min ? sizes[props.min] : undefined;
	const max = props.max ? sizes[props.max] - 1 : undefined;

	if (min) {
		query.push(`(min-width: ${min}px)`);
	}

	if (max) {
		query.push(`(max-width: ${max}px)`);
	}

	if (props.pointer === "touch") {
		query.push("(pointer: coarse)");
	}

	if (props.pointer === "no-touch") {
		query.push("(pointer: fine)");
	}

	return useMediaQueryHook(query.join(" and "));
}
